/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import React from 'react'
import TysiaIconAdd from 'DesignSystem/Svgs/TysiaIconAdd/index'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Topbar/PatientFlowActions/NewPatient/Content",
  onMouseEnter,
  onMouseLeave,
  hovered,
  selected
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({onMouseEnter,onMouseLeave})
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let dtColorsNeutral800 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.800'
        })
let dtColorsNeutral700 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.700'
        })
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
  return (<React.Fragment
>
<button
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 onClick={() => setFlowTo("/App/Account/NewPatient/Content")}
 {...isHoveredBind}
 onMouseEnter={onMouseEnter}
 onMouseLeave={onMouseLeave}
 style={{'--bc-1-Z1Yf8zk': hovered ? dtColorsNeutral700 : selected ? dtColorsNeutral700 : dtColorsNeutral800}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaIconAdd
  viewPath={`${viewPath}/TysiaIconAdd`}
 width={16}
 height={16}
 fill={dtColorsWhite}
/>
</button>
{children}
</React.Fragment>)
}